
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.82 15.82V6.68H2.18v9.14h11.64zm-2.5-15H13V2.5h.82c.443 0 .834.17 1.172.508.339.338.508.729.508 1.172v11.64c0 .443-.17.834-.508 1.172-.338.339-.729.508-1.172.508H2.18c-.47 0-.873-.156-1.211-.469a1.724 1.724 0 01-.469-1.21V4.18c0-.443.156-.834.469-1.172a1.653 1.653 0 011.21-.508H3V.82h1.68V2.5h6.64V.82zm.86 9.18v4.18H8V10h4.18z","fill":"currentColor"}})])
          )
        }
      }
    